'use strict';

module.exports = require('./lib')



/*****************
 ** WEBPACK FOOTER
 ** ./~/@holidayextras/jsonapi-client/~/promise/index.js
 ** module id = 839
 ** module chunks = 0
 **/